export enum WidgetEventType {
	RESIZE = "WIDGET.RESIZE",
}
